import { AbstractControl } from '@angular/forms';

export class ContextualMenuEvent {
    public constructor(
        public sourceControl: AbstractControl,
        public event: MouseEvent
    ) {}
}
